// src/components/AboutUs.jsx
import styles from "./Nosotros.module.css";

export default function Nosotros() {
  return (
    <section className={styles.aboutUs}>
      <h2 className={styles.title}>NUESTRO ESTUDIO</h2>

      <div className={styles.topSection}>
        <div className={styles.text}>
          <p className={styles.description}>
            Se encuentran al frente del estudio Fernando De Vivo (Contador Público Nacional y
            Administrador de Empresas), Agustina De Vivo (Contadora Pública Nacional), Julieta De
            Vivo (Contadora Pública Nacional) y Sergio Imprenta (Contador Público Nacional),
            matriculados en el Consejo Profesional de Ciencias Económicas de la Ciudad Autónoma
            de Buenos Aires, con amplia experiencia en Estudios Contables de primer nivel
            Fernando De Vivo es graduado de la Universidad de Buenos Aires y también posee el
            título de Licenciado en Administración de Empresas. Agustina De Vivo es graduada de la
            Universidad Argentina de la Empresa, y adicionalmente realizó el “IFRSs Learning and
            Assessment Programme” en la Universidad Austral. Julieta De Vivo es graduada de la
            Universidad Argentina de la Empresa. Sergio Imprenta es graduado de la Universidad de
            Buenos Aires,  especialista en PYMES.  Adicionalmente, han participado en 
            numerosos cursos de especialización, lo que les ha permitido
            adquirir sólidos conocimientos en distintas áreas. Contamos, además,
            con un equipo de expertos para lograr un asesoramiento continuo que
            lleve a tu empresa al siguiente nivel. Nuestra cartera de clientes
            se encuentra mayoritariamente en la Ciudad Autónoma y Provincia de
            Buenos Aires. Complementamos el seguimiento con contactos periódicos
            mediante videollamadas y visitas personales a empresas, según lo
            amerite.
          </p>
        </div>
        <div className={styles.imageContainer}>
          <img
            src="/images/aboutus.png"
            alt="Sobre nosotros"
            className={styles.image}
          />
        </div>
      </div>

      <div className={styles.cards}>
        <div className={styles.card}>
          <h3>NUESTRA MISIÓN</h3>
          <p className={styles.description}>
            Nuestro objetivo es brindar a nuestros clientes un servicio
            profesional, con una asistencia permanente en todos los aspectos
            Societarios, Contables, Impositivos y Previsionales desde los
            inicios de su proyecto comercial. Queremos generar valor
            ofreciéndoles soluciones a sus necesidades y buscamos en todo
            momento la satisfacción del cliente. Nuestros clientes nos reconocen
            día a día gracias a la calidad y eficiencia de nuestro servicio
            profesional que ofrecemos con mucha dedicación.{" "}
          </p>
        </div>
        <div className={styles.card}>
          <h3>NUESTROS VALORES</h3>
          <ul>
            <li className={styles.description}>
              Ética, honestidad y transparencia
            </li>
            <li className={styles.description}>Compromiso</li>
            <li className={styles.description}>Profesionalismo</li>
            <li className={styles.description}>Responsabilidad</li>
            <li className={styles.description}>Confidencialidad</li>
            <li className={styles.description}>Integridad y respeto</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
